export type ButtonTypesT = 'reset' | 'submit' | undefined;

export type InputTypesT = 'email' | 'tel' | 'text' | 'checkbox' | 'password' | undefined;

export type User = {
  name: string;
  role: 'admin' | 'speaker' | 'host' | 'listener';
};

export enum UserLoginType {
  custom = 'custom',
  regular = 'regular',
  sms = 'sms',
  none = '',
}

export enum EMOJI_TYPES {
  LIKE = 'like',
  HEART = 'heart',
  SMILE = 'smile',
  WONDER = 'wow',
  CRY = 'cry',
  ANGRY = 'angry',
}
